import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#066542",
      d: "M15.622 4.22a.75.75 0 1 1 1.06 1.06L9.963 12l6.72 6.72.052.056a.75.75 0 0 1-1.055 1.056l-.057-.052-7.25-7.25a.75.75 0 0 1 0-1.06z"
    }, null, -1)
  ]))]))
}
export default { render: render }